import axios from "axios";
import axiosInstance from "./axiosInstance";

const queryString = require("query-string");

class CategoriaRepresentativaApi {
  cancelTokens = {
    getCategoriasRepresentativas: null,
    getCategoriaRepresentativa: null,
    setCategoriaRepresentativa: null,
    destroyCategoriaRepresentativa: null,
  };

  isCancel(exceptionThrown) {
    return axios.isCancel(exceptionThrown);
  }

  async getCategoriasRepresentativas({ page = 1, qtd_por_pagina, nome, sigla_categoria, ativo }) {
    const query = queryString.stringify({
      page,
      qtd_por_pagina,
      nome,
      sigla_categoria,
      ativo,
    });

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getCategoriasRepresentativas = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/categorias_representativas?${query}`,
      {
        cancelToken: source.token,
      }
    );

    if (data && data.resultados) {
      const preposicoes = ['de', 'da', 'do', 'das', 'dos', 'e', 'com', 'em', 'para', 'por', 'di'];

      data.resultados = data.resultados.map(item => ({
        ...item,
        nome: item.nome ? item.nome.split(' ').map((palavra, index) => {
          const palavraBaixa = palavra.toLowerCase();
          
          // Mantém preposições em minúsculo, a menos que seja a primeira palavra
          if (preposicoes.includes(palavraBaixa) && index !== 0) {
            return palavraBaixa;
          }
          
          // Para siglas curtas (até 3 letras), você pode optar por manter maiúsculo ou capitalizar
          // Se quiser capitalizar tudo:
          return palavraBaixa.charAt(0).toUpperCase() + palavraBaixa.slice(1);
        }).join(' ') : ''
      }));
    }

    this.cancelTokens.getCategoriasRepresentativas = null;
    return data;
  }

  async getCategoriaRepresentativa(categoriaRepresentativaId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getCategoriaRepresentativa = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/categorias_representativas/${categoriaRepresentativaId}`,
      {
        cancelToken: source.token,
      }
    );

    if (data && data.nome) {
      const preposicoes = ['de', 'da', 'do', 'das', 'dos', 'e', 'com', 'em', 'para', 'por', 'di'];
      data.nome = data.nome.split(' ').map((p, i) => 
        (preposicoes.includes(p.toLowerCase()) && i !== 0) ? p.toLowerCase() : p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()
      ).join(' ');
    }

      this.cancelTokens.getCategoriaRepresentativa = null;

      return data;
    }

  async destroyCategoriaRepresentativa(categoriaRepresentativaId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.destroyCategoriaRepresentativa = source;

    ("Chamando a API para excluir a categoria com o ID:", categoriaRepresentativaId);

    const { data } = await axiosInstance.delete(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/categorias_representativas/${categoriaRepresentativaId}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.destroyCategoriaRepresentativa = null;
    return data;
  }

  async setCategoriaRepresentativa(categoriaRepresentativa) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
  
    this.cancelTokens.setCategoriaRepresentativa = source;
  
    if (categoriaRepresentativa.id) {
        const { data } = await axiosInstance.put(
            `${process.env.VUE_APP_BASE_API_URL}/api/v1/categorias_representativas/${categoriaRepresentativa.id}`,
            {
                cancelToken: source.token,
                categoria_representativa: {
                    nome: categoriaRepresentativa.nome,
                    sigla_categoria: categoriaRepresentativa.sigla_categoria,
                    ativo: categoriaRepresentativa.ativo,
                },
            },
        );
  
        this.cancelTokens.setCategoriaRepresentativa = null;
        return data;
    } else {
        const { data } = await axiosInstance.post(
            `${process.env.VUE_APP_BASE_API_URL}/api/v1/categorias_representativas`,
            {
                cancelToken: source.token,
                categoria_representativa: {
                    nome: categoriaRepresentativa.nome,
                    sigla_categoria: categoriaRepresentativa.sigla_categoria,
                    ativo: categoriaRepresentativa.ativo,
                },
            },
        );
  
        this.cancelTokens.setCategoriaRepresentativa = null;
        return data;
    }
}

}  

export default CategoriaRepresentativaApi;
